<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12>
						<label>Nombre</label>
						<BaseInput
							:height="38"
							label="Nombre"
							required
							v-model="$v.model.code.$model"
							:error="$v.model.code.$error"
						/>
					</v-flex>
					<v-flex xs12>
						<app-date-select
							hide-details
							label="Fecha Inicial"
							:date-formatted="model.startDate"
							model="startDate"
							class="mt-2"
							@input="getDate"
						></app-date-select>
					</v-flex>
					<v-flex xs12>
						<app-date-select
							hide-details
							label="Fecha Final"
							:date-formatted="model.deadline"
							model="deadline"
							class="mt-2"
							@input="getDate"
						></app-date-select>
					</v-flex>
					<v-flex xs12>
						<app-date-select
							hide-details
							label="Fecha de Presentación"
							:date-formatted="model.datePresentation"
							model="datePresentation"
							class="mt-2"
							@input="getDate"
						></app-date-select>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						success-text="Aceptar"
						@cancel-button-clicked="$emit('on-close')"
						@accept-button-clicked="submitForm"
						:is-loading="disabled"
					></modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { addDays, format } from 'date-fns';
import appDateSelect from '@/components/shared/app-date-select';

function created() {
	this.loadPeriod();
}

function disabled() {
	return this.$v.$invalid || this.loading;
}

async function loadPeriod() {
	try {
		await this.loadData(`period-details/${this.id}`);
		const { code, deadline, datePresentation, startDate } = this.periods;
		this.model = { code, deadline, datePresentation, startDate };
		this.model.startDate = format(addDays(startDate, 1), 'YYYY-MM-DD');
		this.model.deadline = format(addDays(deadline, 1), 'YYYY-MM-DD');
		this.model.datePresentation = format(datePresentation, 'YYYY-MM-DD');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

async function submitForm() {
	this.loading = true;
	this.model = {
		...this.model,
		transactionBlocking: this.transactionBlocking,
		transactionBlockingModule: this.transactionBlockingModule,
	};
	try {
		await this.$http.patch(`period/${this.id}`, this.model);
		this.showNotification('Periodo contable actualizado correctamente.');
		this.$emit('on-close');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		this.loading = false;
	}
}

function getDate({ value, model }) {
	this.model[model] = format(value, 'YYYY-MM-DD');
}

function validations() {
	return {
		model: {
			code: { required },
			datePresentation: { required },
			deadline: { required },
			startDate: { required },
		},
	};
}

function data() {
	return {
		loading: false,
		model: {
			deadline: null,
			code: null,
			datePresentation: null,
			startDate: null,
		},
		transactionBlocking: null,
		transactionBlockingModule: {
			sales: null,
			purchases: null,
			accountsReceivable: null,
			accountsPayable: null,
			treasury: null,
			declarations: null,
		},
	};
}

export default {
	name: 'accounting-period-form',
	components: {
		// BaseDate: () => import('@/components/shared/inputs/base-date'),
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		appDateSelect,
	},
	computed: {
		disabled,
	},
	created,
	data,
	methods: {
		getDate,
		loadPeriod,
		submitForm,
	},
	props: {
		id: [Number, String],
	},
	validations,
};
</script>

<style lang="scss" scoped>
label {
	font-size: size(small);
}
</style>



// WEBPACK FOOTER //
// src/components/accounting-periods/accounting-period-form.vue